import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

interface CustomInputProps extends Omit<TextFieldProps, "variant"> {
  variant?: "outlined" | "filled" | "standard";
}

export const Input: React.FC<CustomInputProps> = ({
  variant = "outlined",
  fullWidth = true,
  margin = "normal",
  ...props
}) => {
  return (
    <TextField
      variant={variant}
      fullWidth={fullWidth}
      margin={margin}
      {...props}
    />
  );
};
